import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1d4c47e4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1d4c47e4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4c47e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/examreg-client-prod-tc/exam-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d4c47e4')) {
      api.createRecord('1d4c47e4', component.options)
    } else {
      api.reload('1d4c47e4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1d4c47e4&scoped=true", function () {
      api.rerender('1d4c47e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/layout/index.vue"
export default component.exports